// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-image {
  border: 1px solid var(--ion-color-primary);
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-person-infobox/ax-person-infobox.component.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,gBAAA;AACF","sourcesContent":[".profile-image {\n  border: 1px solid var(--ion-color-primary);\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
